export default {
  FETCH_NEEDS_ASSESSMENT_LIST: 'FETCH_NEEDS_ASSESSMENT_LIST',
  FETCH_NEEDS_ASSESSMENT_LIST_SUCCESS: 'FETCH_NEEDS_ASSESSMENT_LIST_SUCCESS',
  FETCH_NEEDS_ASSESSMENT_LIST_FAILURE: 'FETCH_NEEDS_ASSESSMENT_LIST_FAILURE',

  SUBMIT_NEEDS_ASSESSMENT_ANSWERS: 'SUBMIT_NEEDS_ASSESSMENT_ANSWERS',
  SUBMIT_NEEDS_ASSESSMENT_ANSWERS_SUCCESS: 'SUBMIT_NEEDS_ASSESSMENT_ANSWERS_SUCCESS',
  SUBMIT_NEEDS_ASSESSMENT_ANSWERS_FAILURE: 'SUBMIT_NEEDS_ASSESSMENT_ANSWERS_FAILURE',

  DELETE_NEEDS_ASSESSMENT: 'DELETE_NEEDS_ASSESSMENT',
  DELETE_NEEDS_ASSESSMENT_SUCCESS: 'DELETE_NEEDS_ASSESSMENT_SUCCESS',
  DELETE_NEEDS_ASSESSMENT_FAILURE: 'DELETE_NEEDS_ASSESSMENT_FAILURE',
};
